(function () {
  'use strict';

  // ==========================================================================
  // CC JOIN — the ONE definition of the multi-value property separator
  // ==========================================================================
  // Every picker that writes several shopper-entered values into a SINGLE
  // line-item property joins them through here:
  //
  //   properties[Initials]      "A B C"                  cc-initial-picker.js
  //   properties[<engraving>]   "ANNA BEN"               cc-text-engraving.js
  //   properties[Birthstones]   "Ruby Peridot Sapphire"  cc-birthstone-picker.js
  //   properties[Birthflowers]  "Carnation Rose Holly"   cc-birthstone-picker.js (paired)
  //                                                      cc-birthflower-picker.js
  //
  // The delimiter is still an OPEN DECISION with Alex — multi-word values
  // ("Blue Topaz", "Rose Quartz", "Morning Glory") are ambiguous in a
  // space-separated list. Space is the current locked-by-legacy behaviour.
  //
  // TO CHANGE THE DELIMITER, EDIT THE NEXT LINE AND NOTHING ELSE.
  var SEP = ' ';

  window.CC_JOIN_SEP = SEP;

  // Joins the already-filtered values in slot order. Callers do their own
  // empty-collapsing where their contract calls for it (multi-slot engraving
  // drops blanks; the stone/flower pickers only ever pass filled slots).
  window.ccJoin = function (values) {
    return (values || []).join(SEP);
  };

  // ==========================================================================
  // CC SUBMIT GATING — the ONE way a picker keeps a blank field off the order
  // ==========================================================================
  // CONTRACT: a blank optional field posts NO line-item property at all, rather
  // than posting the key with an empty value.
  //
  // Shopify will NOT do this for us — probed directly on this store, a "" value
  // and a whitespace-only value both persist onto the cart line.
  //
  // DO NOT implement it by removing the control's `name`. Pipeline's
  // ProductFormReader CACHES every [name^="properties"] control at construction
  // and then, on each variant change, runs
  //
  //     /(?:^(properties\[))(.*?)(?:\])/.exec(input.name)[2]
  //
  // over that cached list. A control whose name has been cleared makes exec()
  // return null, the [2] deref throws, and that throw aborts the chain which
  // writes input[name="id"] — the variant silently stops following the swatches
  // and the WRONG variant is added to cart. Renaming to something inert does not
  // help either: the element is still in the cached list and still fails the
  // regex. The name must stay exactly the properties[...] key it started as.
  //
  // So we take the control out of the FORM while leaving it in the PAGE. A
  // form-associated element whose `form` attribute names no existing form has NO
  // form owner, so new FormData(form) skips it. Both submit paths build from the
  // form — Pipeline's handleClickAddButton does `new FormData(this.form)` and
  // cc-pipeline-bridge.js's photo POST does the same — so the key is absent from
  // the order either way. The control keeps its name and its position, and stays
  // focusable and typeable. `disabled` was rejected for exactly that reason: a
  // disabled control cannot be focused, so the shopper could never fill it.
  var VOID_FORM = 'cc-unsubmitted';

  window.CC_VOID_FORM = VOID_FORM;

  // THE STANDARD. Every picker — existing or future — suppresses a blank field
  // through this and nothing else. Pass the control that carries the
  // properties[...] name (for multi-value blocks that is the hidden output, not
  // the visible boxes). Call it on init AND on every input event.
  window.ccSubmitWhenFilled = function (el) {
    if (!el) return;
    var value = el.value == null ? '' : String(el.value);
    if (value.trim() !== '') {
      el.removeAttribute('form');
    } else {
      el.setAttribute('form', VOID_FORM);
    }
  };

  // For controls that are pure UI and must NEVER post a key of their own — e.g.
  // the per-slot boxes the engraving block builds, whose combined value is
  // written to one hidden output. They still need a name: a nameless control is
  // what breaks the serialiser above the moment its list is re-queried. The
  // inert name must NOT begin with "properties" or "options", or the cached
  // selectors would pick it up.
  window.ccNeverSubmit = function (el, inertName) {
    if (!el) return;
    el.setAttribute('name', inertName);
    el.setAttribute('form', VOID_FORM);
  };

  // ==========================================================================
  // NUMBERED LINE-ITEM PROPERTIES — Alex's order/fulfillment format
  // ==========================================================================
  // Multi-value pickers write ONE property per filled slot, in slot order,
  // numbered only when there is more than one:
  //
  //   3 stones -> properties[Birthstone 1] = "Citrine (November)"
  //               properties[Birthstone 2] = "Blue Topaz (December)"
  //               properties[Birthstone 3] = "Garnet (January)"
  //   1 stone  -> properties[Birthstone]   = "Citrine (November)"
  //   2 names  -> properties[Name 1] = "Jo Ann", properties[Name 2] = "Mary"
  //
  // This REPLACES ccJoin for stones, flowers and multi-name engraving, and is
  // what removes the "Lily of the Valley Rose" ambiguity — a space-joined list
  // of multi-word values could not be split back into the original picks.
  //
  // ccJoin is deliberately STILL used for Initials: Alex wants that left as one
  // simple "A B C" property, and single letters are never ambiguous.
  //
  // These inputs are created AFTER Pipeline's ProductFormReader has cached its
  // [name^="properties"] list, so they never reach the regex that made a
  // cleared name throw (see ccSubmitWhenFilled). They are ordinary named inputs
  // inside the product form, so BOTH submit paths pick them up: Pipeline's
  // `new FormData(this.form)` and cc-pipeline-bridge.js's photo POST.
  //
  // Callers pass only the values they want to post; blanks are dropped here, so
  // an empty slot never produces an empty property.
  window.ccWriteNumberedProps = function (host, base, values) {
    if (!host || !base) return 0;

    var tag = 'cc-prop-' + String(base).toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var previous = host.querySelectorAll('[data-cc-prop-out="' + tag + '"]');
    for (var i = 0; i < previous.length; i++) {
      previous[i].parentNode.removeChild(previous[i]);
    }

    var list = [];
    (values || []).forEach(function (v) {
      if (v != null && String(v).trim() !== '') list.push(String(v));
    });

    for (var n = 0; n < list.length; n++) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-cc-prop-out', tag);
      input.setAttribute('name', 'properties[' + base + (list.length > 1 ? ' ' + (n + 1) : '') + ']');
      input.value = list[n];
      host.appendChild(input);
    }
    return list.length;
  };

  // The legacy single space-joined input each picker shipped with is retired,
  // but it CANNOT simply be deleted or renamed: Pipeline cached it at init and
  // still regex-matches its name on every variant change. Blank it and take it
  // out of the form instead, exactly like any other empty optional field.
  window.ccRetireJoinedInput = function (el) {
    if (!el) return;
    el.disabled = false;
    el.value = '';
    window.ccSubmitWhenFilled(el);
  };

  // "november" -> "November". Month keys come from the chart cells' data-month.
  window.ccMonthName = function (month) {
    var s = String(month == null ? '' : month).trim();
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  // Loaded FIRST in snippets/cc-atelier-pickers.liquid, ahead of every picker.
  // All the picker scripts are `defer`, so the browser runs them in document
  // order and window.ccJoin / ccSubmitWhenFilled / ccNeverSubmit are always
  // defined before any picker runs.
})();
